import { render } from "./standings-phone.vue?vue&type=template&id=08187e07&scoped=true"
import script from "./standings-phone.vue?vue&type=script&lang=js"
export * from "./standings-phone.vue?vue&type=script&lang=js"

import "./standings-phone.vue?vue&type=style&index=0&id=08187e07&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08187e07"]])

export default __exports__